import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    Chip,
    Stack,
    IconButton,
    Tooltip,
} from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import INVOICE_STATUS_OPTIONS_COLORS from "./../enums/invoiceStatusOptionsColors"; // adjust path

const STATUS_ORDER = ["PENDING", "PAID", "OVERDUE", "CANCELLED"];

// tiny dot box reused in menu + chips
const Dot = ({ color, size = 10 }) => (
    <Box sx={{ width: size, height: size, borderRadius: "50%", bgcolor: color, flex: "0 0 auto" }} />
);

// lookup helpers
const colorOf = (label) => {
    const hit = INVOICE_STATUS_OPTIONS_COLORS.find(x => String(x.label).toUpperCase() === String(label).toUpperCase());
    return hit ? hit.color : "#999";
};

export default function InvoiceStatusFilter({
                                                value = [],               // array of selected statuses, e.g. ["PAID","PENDING"]
                                                onChange = () => {},      // (nextArray) => void
                                                label = "Filter by status",
                                                allowAll = true,
                                            }) {
    const ALL = "__ALL__";
    const options = STATUS_ORDER.map(k => ({ label: k, color: colorOf(k) }));


    const handleChange = (event) => {
        const next = event.target.value; // array from MUI

        // If user picked only "All", treat as empty selection
        if (next.includes(ALL) && next.length === 1) {
            onChange([]);
            return;
        }

        // Otherwise, remove the ALL sentinel if it slipped in
        onChange(next.filter(v => v !== ALL));
    };


    const isAll = value.length === 0; // we treat "no selection" as All
    const menuValue = isAll && allowAll ? [ALL] : value;

    return (
        <Stack direction="row" alignItems="center" spacing={1} sx={{marginTop:'4px'}}>
            <FormControl size="small" sx={{ minWidth: 240,  }}>
                <InputLabel id="invoice-status-filter-label">{label}</InputLabel>
                <Select
                    labelId="invoice-status-filter-label"
                    multiple
                    label={label}
                    value={menuValue}
                    onChange={handleChange}
                    renderValue={(selected) => {
                        if (allowAll && selected.includes(ALL)) {
                            return "All statuses";
                        }
                        // render chips for selected statuses
                        return (
                            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                                {selected.map(s => (
                                    <Chip
                                        key={s}
                                        size="small"
                                        label={s.charAt(0) + s.slice(1).toLowerCase()}
                                        icon={<Dot color={colorOf(s)} size={8} />}
                                        sx={{
                                            "& .MuiChip-icon": { ml: "4px" },
                                            bgcolor: "#f6f7f8",
                                        }}
                                    />
                                ))}
                            </Box>
                        );
                    }}
                    MenuProps={{ PaperProps: { style: { maxHeight: 360 } } }}
                    variant="outlined">
                    {allowAll && (
                        <MenuItem value={ALL}>
                            <Checkbox checked={isAll} />
                            <ListItemText primary="All statuses" />
                        </MenuItem>
                    )}

                    {options.map(opt => (
                        <MenuItem key={opt.label} value={opt.label}>
                            <Checkbox checked={value.includes(opt.label)} />
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Dot color={opt.color} />
                                <ListItemText primary={opt.label.charAt(0) + opt.label.slice(1).toLowerCase()} />
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Quick clear */}
            <Tooltip title="Clear filter">
        <span>
          <IconButton
              size="small"
              onClick={() => onChange([])}
              disabled={isAll}
          >
            <ClearAllIcon fontSize="small" />
          </IconButton>
        </span>
            </Tooltip>
        </Stack>
    );
}
